import { render, staticRenderFns } from "./apex-recording-chart.vue?vue&type=template&id=5b22fdac&scoped=true"
import script from "./apex-recording-chart.vue?vue&type=script&lang=js"
export * from "./apex-recording-chart.vue?vue&type=script&lang=js"
import style0 from "./apex-recording-chart.vue?vue&type=style&index=0&id=5b22fdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22fdac",
  null
  
)

export default component.exports